
import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { BANNER_SIZES, BannerSize } from '@/types/banner';
import { getPopularBannerSizes } from '@/utils/banner/bannerHelpers';

interface BannerSpecificationsPanelProps {
  selectedSize: BannerSize;
  onSizeChange: (size: BannerSize) => void;
}

const BannerSpecificationsPanel: React.FC<BannerSpecificationsPanelProps> = ({
  selectedSize,
  onSizeChange,
}) => {
  // Get popular banner sizes for highlighting
  const popularSizes = getPopularBannerSizes();
  const popularSizeValues = popularSizes.map(size => size.value);

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="banner-size">Select Banner Size</Label>
        <Select 
          value={selectedSize} 
          onValueChange={(value) => onSizeChange(value as BannerSize)}
        >
          <SelectTrigger className="w-full mt-1">
            <SelectValue placeholder="Choose a banner size" />
          </SelectTrigger>
          <SelectContent>
            {BANNER_SIZES.map((size) => (
              <SelectItem key={size.value} value={size.value}>
                <span className="flex items-center justify-between w-full">
                  <span>
                    {popularSizeValues.includes(size.value) && <span className="text-primary font-medium">* </span>}
                    {size.name}
                  </span> 
                  <span className="text-gray-500 text-xs ml-2">({size.width}×{size.height})</span>
                </span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        
        {/* Show selected size details */}
        {selectedSize && (
          <div className="mt-2 text-sm text-gray-500">
            <p>
              <span className="font-medium">Selected:</span>{' '}
              {BANNER_SIZES.find(s => s.value === selectedSize)?.name}{' '}
              ({BANNER_SIZES.find(s => s.value === selectedSize)?.width} ×{' '}
              {BANNER_SIZES.find(s => s.value === selectedSize)?.height} pixels)
            </p>
            <p className="text-xs mt-1">* Popular banner sizes</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BannerSpecificationsPanel;
